import Dashboard from "../pages/dashboard/Dashboard";
import CreatePages from "../pages/pagesmanagement/CreatePages";
import FeaturedEvents from "../pages/websiteCms/featuredEvents/FeaturedEvents";
import CorporateMemberDirectory from "../pages/websiteCms/corporateMemberDirectory/CorporateMemberDirectory";
import AddEditCouncilDetails from "../pages/websiteCms/manageLeadershipPosition/AddEditCouncilDetails";
import ManageSecretariatDetails from "../pages/websiteCms/secretariatMember/ManageSecretariatDetails";
import AddEditSecretariatDetails from "../pages/websiteCms/secretariatMember/AddEditSecretariatDetails";
import ManageFeaturedNewMembers from "../pages/websiteCms/featuredNewMembers/ManageFeaturedNewMembers";
import AddFeaturedNewMember from "../pages/websiteCms/featuredNewMembers/AddFeaturedNewMember";
import Privileges from "../pages/websiteCms/privileges/Privileges";
import CreatePrivilegesPost from "../pages/websiteCms/privileges/CreatePrivilegesPost ";
import ViewResource from "../pages/resources/ViewResource";
import CreateResources from "../pages/resources/CreateResources";
import AddEditSpotlight from "../pages/websiteCms/spotlight/AddEditSpotlight";
import ManageSpotlights from "../pages/websiteCms/spotlight/ManageSpotlights";
import SGTechTv from "../pages/sgTechTv/SGTechTv";
import UploadSGTechTV from "../pages/sgTechTv/UploadSGTechTV";
import BannerUpload from "../pages/bannermanagement/BannerUpload";
import PostApproval from "../pages/resources/PostApproval";
import PreviewResources from "../pages/resources/PreviewResources";
import CreatePreviewResource from "../pages/resources/CreatePreviewResource";
import EditResources from "../pages/resources/EditResources";
import MembershipPricing from "../pages/membership/membershipPricing/MembershipPricing";
import MembershipCampaign from "../pages/membership/membershipCampaign/MembershipCampaign";
import AddEditMembershipCampaign from "../pages/membership/membershipCampaign/membershipAddEditCompaign/AddEditMembershipCampaign";
import ViewPages from "../pages/pagesmanagement/ViewPages";
import AuthorityLimit from "../pages/membership/AuthorityLimit";
import NotificationAnnouncemnet from "../pages/membership/NotificationAnnouncement";
import MembershipTaskList from "../pages/membership/membershipTaskList/MembershipTaskList";
import MembershipRenewalDashboard from "../pages/membership/membershipRenewalDashboard/MembershipRenewalDashboard"
import MembershipFeeApproval from "../pages/membership/membershipFeeApproval/MembershipFeeApproval";
import ChapterXCommitteeWorkgroupMapping from "../pages/membership/chapterXCommitteeWorkgroupMapping/ChapterXCommitteeWorkgroupMapping";
import EditPages from "../pages/pagesmanagement/EditPages";
import ViewCorporateMembers from "../pages/membership/corporateMembers/ViewCorporateMembers";
import CreateCorporateMembers from "../pages/membership/corporateMembers/CreateCorporateMembers";
import IndividualMembers from "../pages/membership/individualMembers/IndivisualMembers";
import CreateIndividualMembers from "../pages/membership/individualMembers/CreateIndividualMembers";
import MarketingTrackingURL from "../pages/entrymanagement/MarketingTrackingURL";
// import AccaTimePicker from '../components/UIComponent/TimePicker/TimePicker';
import ViewEditEntries from "../pages/entrymanagement/ViewEditEntries";
import CreateEntry from "../pages/entrymanagement/CreateEntry";
import CategoryCampaignTagging from "../pages/entrymanagement/CategoryCampaignTagging";
import Partnerships from "../pages/partnerships/Partnerships";
import ProjectReview from "../pages/partnerships/ProjectReview";
import AddEditGovernmentPartner from "../pages/partnerships/AddEditGovernmentPartner";
// import SGTechTv2 from '../pages/sgTechTv/SGTechTv2';
import CreateIndividualMembersNew from "../pages/membership/individualMembers/CreateIndividualMembersNew";
import AddEditStrategicMember from "../pages/partnerships/AddEditStrategicMember";
import AddEditProject from "../pages/partnerships/AddEditProject";
import CreateAdminAccount from "../pages/accountManagement/CreateAdminAccount";
import ViewEditAdminAccount from "../pages/accountManagement/ViewEditAdminAccount";
import DropdownManagement from "../pages/fieldManagement/DropdownManagement";
import EmailTemplateManagement from "../pages/fieldManagement/EmailTemplateManagement";
import EmailHistory from "../pages/emailManagement/EmailHistory";
import CreateEmail from "../pages/emailManagement/CreateEmail";
import ManagePages from "../pages/pagesmanagement/ManagePages";
import ChaptersCommitteePrieview from "../components/bannerManagement/ChaptersCommitteePrieview";
import BannerPreview from "../pages/bannermanagement/BannerPreview";
import MobileBannerPreview from "../components/bannerManagement/MobileBannerPreview";
import MembershipDirectoryEnquiry from "../pages/membership/membershipDirectoryEnquiry/MembershipDirectoryEnquiry";
import ManageTags from "../pages/fieldManagement/ManageTags";
import CreateEmailTemplate from "../components/fieldManagement/CreateEmailTemplate";
import MembershipReport from "../pages/membershipReports/MembershipReport";
import MembershipCommittee from "../pages/fieldManagement/MembershipCommittee";
import ManagementCommittee from "../pages/fieldManagement/ManagementCommittee";

// Financial Start
import GlobalSettingFinance from "../pages/financial/GlobalSettingFinance";
import ChartsOfAccounts from "../pages/financial/ChartsOfAccounts";
import PaymentReconcilation from "../pages/financial/PaymentReconcilation";
// import CreditNoteApprovalProcess from "../pages/financial/CreditNoteApprovalProcess";
import BatchJobExtraction from "../pages/financial/BatchJobExtraction";
import CreditNoteApproval from "../pages/financial/CreditNoteApproval";
import AddEditExternalInvoice from "../pages/financial/AddEditExternalInvoice";
import CreditNoteManagement from "../pages/financial/CreditNoteManagement";
import ExternalInvoices from "../pages/financial/ExternalInvoices";
import ViewBookingDetail from "../pages/financial/ViewBookingDetail";
// import Accountpayable from "../pages/financial/Accountpayable";
import ViewBookingCancellation from "../pages/booking/ViewBookingCancellation";
import ViewNewBookings from "../pages/booking/ViewNewBookings";
import NewBookingCancellationDetail from "../pages/booking/NewBookingCancellationDetail";
import UnAuthorized from "../pages/authentication/UnAuthorized";
import PageNotFound from "../pages/pageNotFound/PageNotFound";
import TestEditorPage from "../pages/TestEditorPage/TestEditorPage";
import VoucherCodeManagement from "../pages/financial/VoucherCodeManagement";
import CreateVoucherCode from "../pages/financial/CreateVoucherCode";
import EventRegistrationApproval from "../pages/financial/EventRegistrationApproval";
import ExtractInvoices from "../pages/financial/ExtractInvoices";
import MembershipDirectoryReport from "../pages/membership/MembershipDirectoryReport"



// Go Global Start
import GoGlobalContactRequest from "../pages/goGlobal/GoGlobalContactRequest";
import GoGlobalAccountApproval from "../pages/goGlobal/GoGlobalAccountApproval";
import ClickAnalytics from "../pages/goGlobal/ClickAnalytics";
import ViewGoGlobalAccount from "../pages/goGlobal/ViewGoGlobalAccount";
import EventFeedbackQuestion from "../pages/entrymanagement/EventFeedbackQuestion";
import ARAgingReport from "../pages/financial/ARAgingReport";
import GSTReport from "../pages/financial/GSTReport";
import FormQuestionAnswer from "../pages/entrymanagement/FormQuestionAnswer";
import VoucherCodeReport from "../pages/financial/VoucherCodeReport";
import TransactionReport from "../pages/financial/TransactionReport";
import OrganisationRoleReport from "../pages/financial/OrganisationRoleReport";
import DeferredIncomeReport from "../pages/financial/DeferredIncomeReport";

// DTSME
import DTSME from "../pages/dtsme/DTSME";
import AddEditDTSMEMember from "../pages/dtsme/AddEditDTSMEMember";
import XeroInvoiceExtraction from "../pages/financial/XeroInvoiceExtraction";
import ReconcilationUploadedData from "../pages/financial/ReconcilationUploadedData";
import DTSMEPurchaseReport from "../pages/dtsme/DTSMEPurchaseReport";
import ChangePassword from "../pages/authentication/ChangePassword"


//publication Report 
import PublicationReport from "../pages/publicationReport/GenAICyberConnectReport"
import MTOPricing from "../pages/membership/mtoPricing/MTOPricing";
import MTOTaskList from "../pages/membership/mtoTaskList/MTOTaskList";
import UpgradeChangeRequestTaskList from "../pages/membership/upgradeChangeRequestTaskList/UpgradeChangeRequestTaskList";
import ManageCouncilDetails from "../pages/websiteCms/manageLeadershipPosition/ManageCouncilDetails";
import OrganisationChart from "../pages/websiteCms/organisationChart/OrganisationChart";
import ManageCommitteeMembers from "../pages/websiteCms/manageCommitteeMembers/ManageCommitteeMembers";
import AddEditCommitteeMembers from "../pages/websiteCms/manageCommitteeMembers/AddEditCommitteeMembers";

// Redas Reports

import MembershipTrackingReport from "../pages/redasReports/MembershipTrackingReport/MembershipTrackingReport";
import AllMemberReports from "../pages/redasReports/allMemberReports/AllMemberReports";
import MemberManagementModule from "../pages/membermanagementmodule/MemberManagementModule";
import AddEditMemberManagementModule from "../pages/membermanagementmodule/AddEditMemberManagementModule";
import EngagementReports from "../pages/redasReports/engagementReports/EngagementReports";

import MemberYearTwoReport from "../pages/redasReports/MemberYearTwoReport";
import MemberMovementReport from "../pages/slaReports/MemberMovementReport/MemberMovementReport";
import EventBookingReport from "../pages/financial/EventBookingReport";
import General from "../pages/evoting/General";
import Candidates from "../pages/evoting/Candidates";
import Report from "../pages/evoting/Report";
import ReportInternal from "../pages/evoting/ReportInternal";


const ComponentNavigation = [
  {
    path: "evoting/general",
    title: "Evoting - General",
    component: General,
    hasParams: false,
    roles: [7, 8]
  },
  {
    path: "evoting/candidates",
    title: "Evoting - Candidates",
    component: Candidates,
    hasParams: false,
    roles: [7, 8]
  },
  {
    path: "evoting/report",
    title: "Evoting - Report",
    component: Report,
    hasParams: false,
    roles: [7, 8]
  },
  {
    path: "evoting/reportInternal",
    title: "Evoting - Report (Internal)",
    component: ReportInternal,
    hasParams: false,
    roles: [8]
  },
  // {
  //   path: "/",
  //   title: "Dashboard",
  //   component: Dashboard,
  //   hasParams: false,
  //   roles: [1,1]
  // },
  {
    path: "Dashboard",
    title: "Dashboard",
    component: Dashboard,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "PageNotFound",
    title: "PageNotFound",
    component: PageNotFound,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14]
  },
  {
    path: "CorporateMemberDirectory",
    title: "Corporate Member Directory",
    previousPath: "Website CMS",
    component: CorporateMemberDirectory,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "ManageCouncilDetails",
    title: "Manage Council Details",
    previousPath: "Website CMS",
    component: ManageCouncilDetails,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "AddEditCouncilDetails",
    title: "Add Council Details",
    previousPath: "Website CMS",
    component: AddEditCouncilDetails,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "AddEditCommitteeMembers",
    title: "Add Committee Details",
    previousPath: "Website CMS",
    component: AddEditCommitteeMembers,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "ManageCommitteeMembers",
    title: "Manage Committee Members",
    previousPath: "Website CMS",
    component: ManageCommitteeMembers,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "OrganisationChart",
    title: "Organisation Chart",
    previousPath: "Website CMS",
    component: OrganisationChart,
    hasParams: false,
    roles: [1, 7, 14]
  },
  // {
  //   path: "AddEditLeadershipPosition",
  //   title: "Edit Leadership Position",
  //   component: AddEditLeadershipPosition,
  //   hasParams: false,
  //   roles: [1, 7, 14]
  // },
  {
    path: "ManageFeaturedNewMembers",
    title: "Manage Featured New Members",
    previousPath: "Website CMS",
    component: ManageFeaturedNewMembers,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "AddFeaturedNewMember",
    title: "Add Featured New Member",
    component: AddFeaturedNewMember,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "EngagementReport",
    title: "Engagement Report",
    previousPath: "Redas Reports",
    component: EngagementReports,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {

    path: "AddEditCouncilDetails/:councilDetailsId",
    title: "Edit Council Details",
    component: AddEditCouncilDetails,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "Privileges",
    title: "Privileges",
    previousPath: "Website CMS",
    component: Privileges,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "FeaturedEvents",
    title: "Featured Events",
    previousPath: "Website CMS",
    component: FeaturedEvents,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "CreatePrivilegesPost",
    title: "Create Privileges Post",
    component: CreatePrivilegesPost,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "ViewResource",
    title: "View Resources",
    previousPath: "Resource",
    component: ViewResource,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 13, 14],
  },
  {
    path: "CreatePreviewResource",
    title: "Create Resource",
    previousPath: "Resource",
    component: CreatePreviewResource,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 13, 14],
  },
  {
    path: "EditResource/:resourceId",
    title: "Edit Resource",
    component: EditResources,
    hasParams: true,
    roles: [1, 7, 2, 9, 10, 11, 13, 14]
  },
  {
    path: "CreatePrivilegesPost/:privilegesId",
    title: "Create Privileges Post",
    component: CreatePrivilegesPost,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "AddEditSpotlight",
    title: "Add New Spotlight",
    previousPath: "Website CMS",
    component: AddEditSpotlight,
    hasParams: false,
    roles: [1, 7, 14],
  },
  {
    path: "AddEditSpotlight/:spotlightId",
    title: "Update Spotlight",
    component: AddEditSpotlight,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "ManageSpotlights",
    title: "Manage Published Spotlights",
    previousPath: "Website CMS",
    component: ManageSpotlights,
    hasParams: false,
    roles: [1, 7, 14],
  },
  {
    path: "AddEditSpotlight/:spotlightId",
    title: "Update Spotlight",
    component: AddEditSpotlight,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "ManageSpotlights",
    title: "Manage Published Spotlights",
    previousPath: "Website CMS",
    component: ManageSpotlights,
    hasParams: false,
    roles: [1, 7, 14],
  },
  {
    path: "ManageSecretariatDetails",
    title: "Manage Secretariat Details",
    previousPath: "Website CMS",
    component: ManageSecretariatDetails,
    hasParams: false,
    roles: [1, 7, 14],
  },
  {
    path: "AddEditSecretariatDetails/:SecretariatDetailsId",
    title: "Update Secretariat Details",
    component: AddEditSecretariatDetails,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "PreviewResources",
    title: "Preview Resources",
    component: PreviewResources,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 13, 14],
  },
  {
    path: "CreateResources",
    title: "Create Resources",
    component: CreateResources,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 13, 14],
  },
  {
    path: "CreateResources/:resourceId",
    title: "Create Resources",
    component: CreateResources,
    hasParams: true,
    roles: [1, 7, 2, 9, 10, 11, 13, 14]
  },
  {
    path: "PostApproval",
    title: "PostApproval",
    previousPath: "Resource",
    component: PostApproval,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 13, 14],
  },
  {
    path: "PostApproval/:resourceId",
    title: "Post Approval",
    previousPath: "Resource",
    component: PostApproval,
    hasParams: true,
    roles: [1, 7, 2, 9, 10, 11, 13, 14]
  },
  {
    path: "SGTechTv",
    previousPath: "WebCMS",
    title: "SGTechTv",
    component: SGTechTv,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "UploadSGTechTV",
    title: "Upload SGTechTV",
    component: UploadSGTechTV,
    hasParams: false,
    roles: [1, 7, 14],
  },
  {
    path: "UploadSGTechTV/:sgTechTVId",
    title: "Upload SGTechTV",
    component: UploadSGTechTV,
    hasParams: true,
    roles: [1, 7, 14]
  },

  {
    path: "bannerUpload/:chapterscommittee",
    previousPath: "Banner Management",
    title: "Banner Upload",
    component: BannerUpload,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "bannerUpload/:events",
    previousPath: "Banner Management",
    title: "Banner Upload",
    component: BannerUpload,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "bannerUpload/:businessopportunities",
    previousPath: "Banner Management",
    title: "Banner Upload",
    component: BannerUpload,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "bannerUpload/:articles",
    previousPath: "Banner Management",
    title: "Banner Upload",
    component: BannerUpload,
    hasParams: true,
    roles: [1, 7, 14]
  },
  // {
  //   path: "bannerUpload/:home",
  //   previousPath: "Banner Management",
  //   title: "Banner Upload",
  //   component: BannerUpload,
  //   hasParams: true,
  //   roles: [1, 7, 14]
  // },
  {
    path: "Membership/Pricing",
    previousPath: "Membership",
    title: "Membership Pricing",
    component: MembershipPricing,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "MembershipCampaign",
    previousPath: "Membership",
    title: "Membership Campaign",
    component: MembershipCampaign,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "AddEditMembershipCampaign",
    previousPath: "Membership",
    title: "Edit Membership Campaign",
    component: AddEditMembershipCampaign,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "ViewPages",
    title: "View Pages",
    component: ViewPages,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 12, 13, 14],
  },
  {
    path: "AddEditMembershipCampaign/:membershipCampaignId",
    previousPath: "Membership",
    title: "Edit Membership Campaign",
    component: AddEditMembershipCampaign,
    hasParams: true,
    roles: [1, 2, 12, 14]
  },
  {
    path: "MemberManagementModule",
    title: "Member Management Module",
    component: MemberManagementModule,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "AddEditMemberManagementModule",
    title: "Add Member Management Module",
    previousPath: "MemberManagementModule",
    component: AddEditMemberManagementModule,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "AddEditMemberManagementModule/:CorporateMemberId",
    title: "Edit Member Management Module",
    previousPath: "MemberManagementModule",
    component: AddEditMemberManagementModule,
    hasParams: true,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "Membership/AuthorityLimit",
    previousPath: "Membership",
    title: "Authority Limit",
    component: AuthorityLimit,
    hasParams: true,
    roles: [1, 4, 2, 12, 14]
  },
  {
    path: "Membership/NotificationAnnouncement",
    previousPath: "Membership",
    title: "Notification Announcement",
    component: NotificationAnnouncemnet,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "CreatePages/:MainMenuId/:SubMenuId/:PageNameId",
    title: "Edit Page Details",
    component: CreatePages,
    hasParams: true,
    roles: [1, 7, 2, 9, 10, 11, 12, 13, 14]
  },
  {
    path: "Membership/MembershipTaskList",
    previousPath: "Membership",
    title: "Membership Task List",
    component: MembershipTaskList,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "Membership/MembershipRenewalDashboard",
    previousPath: "Membership",
    title: "Membership Renewal Dashboard",
    component: MembershipRenewalDashboard,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "Membership/MembershipFeeApproval",
    previousPath: "Membership",
    title: "Membership Fee Approval",
    component: MembershipFeeApproval,
    hasParams: false,
    roles: [1, 4],
  },
  {
    path: "Membership/ChapterXCommitteeWorkgroupMapping",
    previousPath: "Membership",
    title: "Chapter X Committee Workgroup Mapping",
    component: ChapterXCommitteeWorkgroupMapping,
    hasParams: false,
    roles: [1, 2, 10, 12, 13, 14,5,6],
  },
  {
    path: "CreatePages",
    title: "Pages Management",
    component: CreatePages,
    hasParams: false,
    roles: [1, 7, 2, 9, 10, 11, 12, 13, 14],
  },
  // {
  //   path: "EditPages/:MainMenuId/:SubMenuId",
  //   title: "Edit Page Details",
  //   component: CreatePages,
  //   hasParams: ,true,
  // },
  // {
  //   path: "EditPages/:MainMenuId/:SubMenuId/:PageNameId",
  //   title: "Edit Page Details",
  //   component: CreatePages,
  //   hasParams: ,true,
  // },
  {
    path: "EditPages/:PagesDetailsId",
    title: "Edit Page Details",
    component: EditPages,
    hasParams: true,
    roles: [1, 7, 2, 9, 10, 11, 12, 13, 14],
  },
  // {
  //   path: "EditPages/:MainMenuId/:SubMenuId",
  //   title: "Edit Page Details",
  //   component: EditPages,
  //   hasParams: ,true,
  // },
  {
    path: "ViewCorporateMembers",
    previousPath: "Membership",
    title: "View Corporate Members",
    component: ViewCorporateMembers,
    hasParams: false,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6],
  },
  {
    path: "CreateCorporateMembers",
    previousPath: "Membership",
    title: "Create Corporate Member",
    component: CreateCorporateMembers,
    hasParams: false,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6],
  },
  {
    path: "CreateCorporateMembers/:CorporateMemberId",
    previousPath: "Membership",
    title: "Edit Corporate Member",
    component: CreateCorporateMembers,
    hasParams: true,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6]
  },
  {
    path: "IndividualMembers",
    previousPath: "Membership",
    title: "View Individual Members",
    component: IndividualMembers,
    hasParams: false,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6],
  },
  {
    path: "CreateIndividualMembers",
    previousPath: "Membership",
    title: "Create Individual Members",
    component: CreateIndividualMembers,
    hasParams: false,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6],
  },
  {
    path: "CreateIndividualMembers/:individualMemberId",
    previousPath: "Membership",
    title: "Create Individual Members",
    component: CreateIndividualMembers,
    hasParams: true,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14,5,6]
  },
  {
    path: "MarketingTrackingURL",
    previousPath: "Entry Management",
    title: "Marketing Tracking URL",
    component: MarketingTrackingURL,
    hasParams: true,
    roles: [1, 7, 9, 10, 11, 12, 2, 13, 14,5,6]
  },
  // { path: 'Ac,caTimePicker', title: 'Acca Time Picker' , component: AccaTimePicker, hasParams: false
  // { path: 'Vi,ewEditEntries', previousPath: 'Entry Management', title: 'View / Edit Entries', component: ViewEditEntries, hasParams: true 
  // { path: 'Cr,eateEntry', previousPath: 'Entry Management', title: 'Create Entry', component: CreateEntry, hasParams: true 
  // { path: 'Ca,tegoryCampaignTagging', previousPath: ' ', title: 'Category & Campaign Tagging', component: CategoryCampaignTagging, hasParams: true 
  // { path: 'Pa,rtnerships', previousPath: ' ', title: 'Partnerships', component: Partnerships, hasParams: true 
  // { path: 'Pr,ojectReview', previousPath: 'Government Programme', title: 'Project Review', component: ProjectReview, hasParams: true 
  // { path: 'Ad,dEditGovernmentPartner', previousPath: 'Government Programme', title: 'Add/Edit Government Partner', component: AddEditGovernmentPartner, hasParams: true 
  // { path: 'CreateIndividualMembersNew', previousPath: 'Membership', title: 'Create Individual Members New', component: CreateIndividualMembersNew, hasParams: false },
  // { path: 'CreateIndividualMembersNew/:individualMemberId', previousPath: 'Membership', title: 'Create Individual Members New', component: CreateIndividualMembersNew, hasParams: true },
  // { path: 'AddEditStrategicMember', previousPath: 'Government Programme', title: 'Add/Edit Strategic Member', component: AddEditStrategicMember, hasParams: false },
  // { path: 'AddEditProject', previousPath: 'Government Programme', title: 'Add/Edit Project', component: AddEditProject, hasParams: false },
  // { path: 'CreateAdminAccount', previousPath: 'Account Management', title: 'Create Admin Account', component: CreateAdminAccount, hasParams: false },
  // { path: 'ViewEditAdminAccount', previousPath: 'Account Management', title: 'View/Edit Admin Account', component: ViewEditAdminAccount, hasParams: false },

  {
    path: "ViewEditEntries",
    previousPath: "Entry Management",
    title: "View / Edit Entries",
    component: ViewEditEntries,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "EventFeedbackQuestion",
    previousPath: "Entry Management",
    title: "View / Edit Entries",
    component: EventFeedbackQuestion,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "FormQuestionAnswer",
    previousPath: "Entry Management",
    title: "View / Edit Entries",
    component: FormQuestionAnswer,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "CreateEntry",
    previousPath: "Entry Management",
    title: "Create Entry",
    component: CreateEntry,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "CreateEntry/:eventId",
    title: "Update Event Details",
    component: CreateEntry,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "CategoryCampaignTagging",
    previousPath: "View/Edit Entry",
    title: "Category & Campaign Tagging",
    component: CategoryCampaignTagging,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },
  {
    path: "CategoryCampaignTagging/:eventId",
    previousPath: "View/Edit Entry",
    title: "Category & Campaign Tagging",
    component: CategoryCampaignTagging,
    roles: [1, 9, 10, 11, 12, 2, 13, 14],
    hasParams: true,
  },


  // {
  //   path: "financial/PaymentReconciliation",
  //   previousPath: "Financial",
  //   title: "Payment Reconciliation",
  //   component: PaymentReconcilation,
  //   roles: [1, 3],
  //   hasParams: false,
  // },



  {
    path: "Partnerships",
    previousPath: " ",
    title: "Partnerships",
    component: Partnerships,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "ProjectReview/:agencyId",
    previousPath: "Government Programme",
    title: "Project Review",
    component: ProjectReview,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "ProjectReview/:isMember/:agencyId",
    previousPath: "Government Programme",
    title: "Project Review",
    component: ProjectReview,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "ProjectReview",
    previousPath: "Government Programme",
    title: "Project Review",
    component: ProjectReview,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "AddEditGovernmentPartner/:AgencyId",
    previousPath: "Government Programme",
    title: "Add/Edit Government Partner",
    component: AddEditGovernmentPartner,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "AddEditGovernmentPartner",
    previousPath: "Government Programme",
    title: "Add/Edit Government Partner",
    component: AddEditGovernmentPartner,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "CreateIndividualMembersNew",
    previousPath: "Membership",
    title: "Create Individual Members New",
    component: CreateIndividualMembersNew,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "CreateIndividualMembersNew/:individualMemberId",
    previousPath: "Membership",
    title: "Create Individual Members New",
    component: CreateIndividualMembersNew,
    roles: [1, 2, 9, 10, 11, 3, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "AddEditStrategicMember",
    previousPath: "Government Programme",
    title: "Add/Edit Strategic Member",
    component: AddEditStrategicMember,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "AddEditProject",
    previousPath: "Government Programme",
    title: "Add/Edit Project",
    component: AddEditProject,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "CreateAdminAccount",
    previousPath: "Account Management",
    title: "Create Admin Account",
    component: CreateAdminAccount,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "CreateAdminAccount/:adminId",
    title: "Create Admin Account",
    component: CreateAdminAccount,
    roles: [1, 8],
    hasParams: true,
  },
  {
    path: "ViewEditAdminAccount",
    previousPath: "Account Management",
    title: "View/Edit Admin Account",
    component: ViewEditAdminAccount,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "DropdownManagement",
    previousPath: "Field Management",
    title: "Dropdown Management",
    component: DropdownManagement,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "MembershipCommittee",
    previousPath: "Field Management",
    title: "Membership Committee",
    component: MembershipCommittee,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "ManagementCommittee",
    previousPath: "Field Management",
    title: "Management Committee",
    component: ManagementCommittee,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "ManageTags",
    previousPath: "Field Management",
    title: "Manage Tags",
    component: ManageTags,
    roles: [1, 8],
    hasParams: false,
  },
  {
    path: "EmailTemplateManagement",
    previousPath: "Field Management",
    title: "Email Template Management",
    component: EmailTemplateManagement,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "CreateEmailTemplate",
    previousPath: "Field Management",
    title: "Create Email Template",
    component: CreateEmailTemplate,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: false,
  },

  {
    path: "CreateEmailTemplate/:emailTemplateId",
    previousPath: "Field Management",
    title: "Create Email Template",
    component: CreateEmailTemplate,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: true,
  },

  {
    path: "EmailHistory",
    previousPath: "Email Management",
    title: "Email History",
    component: EmailHistory,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "CreateEmail",
    previousPath: "Email Management",
    title: "Create Email",
    component: CreateEmail,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: false,
  },

  {
    path: "CreateEmail/:emailManagementId",
    previousPath: "",
    title: "",
    component: CreateEmail,
    roles: [1, 8, 2, 10, 7, 9, 12, 13, 14],
    hasParams: true,
  },

  {
    path: "ManagePages",
    previousPath: "Page Management",
    title: "Manage Pages",
    component: ManagePages,
    roles: [1],
    hasParams: false,
  },
  {
    path: "ChaptersCommitteePrieview",
    previousPath: "Banner Management",
    title: "Chapters Committee Banner",
    component: ChaptersCommitteePrieview,
    roles: [1, 7, 14],
    hasParams: false,
  },
  {
    path: "BannerPreview",
    title: "Banner Preview",
    component: BannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "BannerPreview/:chapterscommittee",
    title: "Banner Preview ",
    component: BannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "BannerPreview/:events",
    title: "Banner Preview ",
    component: BannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "BannerPreview/:businessopportunities",
    title: "Banner Preview ",
    component: BannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "BannerPreview/:articles",
    title: "Banner Preview ",
    component: BannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "ManagePages/:pagesDetailsId",
    previousPath: "Page Management",
    title: "Manage Pages",
    component: ManagePages,
    roles: [1],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview/:chapterscommittee",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview/:events",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview/:businessopportunities",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview/:articles",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "MobileBannerPreview/:home",
    title: "Mobile Banner Preview",
    component: MobileBannerPreview,
    roles: [1, 7, 14],
    hasParams: true,
  },
  {
    path: "AddEditProject/:projectId",
    previousPath: "Government Programme",
    title: "Add/Edit Project",
    component: AddEditProject,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "Membership/MembershipDirectoryEnquiry",
    previousPath: "Membership",
    title: "Membership Directory Enquiry",
    component: MembershipDirectoryEnquiry,
    roles: [1, 2, 12, 14],
    hasParams: false,
  },

  {
    path: "Membership/MembershipDirectoryReport",
    previousPath: "Membership",
    title: "Membership Directory Report",
    component: MembershipDirectoryReport,
    roles: [1, 2, 12, 14],
    hasParams: false,
  },

  // Financial
  {
    path: "financial/GlobalSettingFinance",
    previousPath: "Financial",
    title: "Global Setting Finance",
    component: GlobalSettingFinance,
    roles: [1, 3, 8],
    hasParams: false,
  },
  {
    path: "financial/ChartsOfAccounts",
    previousPath: "Financial",
    title: "Charts of Accounts",
    component: ChartsOfAccounts,
    roles: [1, 3],
    hasParams: false,
  },
  {
    path: "financial/PaymentReconciliation",
    previousPath: "Financial",
    title: "Payment Reconciliation",
    component: PaymentReconcilation,
    roles: [1, 3],
    hasParams: false,
  },
  {
    path: "financial/ReconcilationUploadedData",
    previousPath: "Financial",
    title: "Reconcilation Uploaded Data",
    component: ReconcilationUploadedData,
    roles: [1, 3],
    hasParams: false,
  },
  // {
  //   path: "financial/CreditNoteApprovalProcess",
  //   previousPath: "Financial",
  //   title: "Credit Note Approval Process",
  //   component: CreditNoteApprovalProcess,
  //   roles : [3],
  //   hasParams: false,
  // },
  {
    path: "financial/BatchJobExtraction",
    previousPath: "Financial",
    title: "Batch Job Extraction",
    component: BatchJobExtraction,
    roles: [1, 3],
    hasParams: false,
  },
  // {
  //   path: "financial/EventBookingReport",
  //   previousPath: "Financial",
  //   title: "Event Booking Report ",
  //   component: EventBookingReport,
  //   roles: [1, 3],
  //   hasParams: false,
  // },
  {
    path: "financial/XeroInvoiceExtraction",
    previousPath: "Financial",
    title: "Xero Invoice Extraction",
    component: XeroInvoiceExtraction,
    roles: [1, 3],
    hasParams: false,
  },
  {
    path: "financial/CreditNoteApproval",
    previousPath: "Financial",
    title: "Credit Note Approval",
    component: CreditNoteApproval,
    roles: [1, 3, 4],
    hasParams: false,
  },
  {
    path: "financial/AddEditExternalInvoice",
    previousPath: "Financial",
    title: "External Invoices",
    component: AddEditExternalInvoice,
    roles: [1, 3],
    hasParams: false,
  },
  // {
  //   path: "financial/Accountpayable",
  //   previousPath: "Financial",
  //   title: "Account payable",
  //   component: Accountpayable,
  //   roles: [1, 3],
  //   hasParams: false,
  // },
  // khushbu 27/9 Start
  {
    path: "financial/CreditNoteManagement/:CreditNoteId",
    previousPath: "Financial",
    title: "Credit Note Management ",
    component: CreditNoteManagement,
    roles: [1, 3, 4],
    hasParams: false,
  },
  {
    path: "financial/ExternalInvoices",
    previousPath: "Financial",
    title: "External Invoices ",
    component: ExternalInvoices,
    roles: [1, 3],
    hasParams: false,
  },
  {
    path: "financial/AddEditExternalInvoice/:financeExternalInvoiceId",
    previousPath: "Financial",
    title: "External Invoices ",
    component: AddEditExternalInvoice,
    roles: [1, 3],
    hasParams: true,
  },
  // {
  //   path: "financial/AddEditExternalInvoice/:financeAdhocInvoiceId",
  //   previousPath: "Financial",
  //   title: "Adhoc Invoices ",
  //   component: AddEditExternalInvoice,
  //   roles : [3],
  //   hasParams: true,
  // },
  {
    path: "financial/ViewBookingDetail/:bookingAttendeeInformationId/:bookingId",
    previousPath: "Financial",
    title: "View Booking Detail ",
    component: ViewBookingDetail,
    roles: [1, 2, 10, 9, 12, 11, 13, 14],
    hasParams: true,
  },
  // khushbu 27/9 End

  {
    path: "financial/VoucherCodeManagement",
    previousPath: "Financial",
    title: "Voucher Code Management",
    component: VoucherCodeManagement,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },

  {
    path: "createVoucherCode/:voucherCodeId",
    previousPath: "VoucherCodeManagement",
    title: "Create Voucher Code",
    component: CreateVoucherCode,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "createVoucherCode",
    previousPath: "VoucherCodeManagement",
    title: "Create Voucher Code",
    component: CreateVoucherCode,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },

  {
    path: "financial/VoucherCodeReport",
    previousPath: "VoucherCodeReport",
    title: "Voucher Code Report",
    component: VoucherCodeReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/ARAgingReport",
    previousPath: "ARAgingReport",
    title: "ARAging Report",
    component: ARAgingReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/GSTReport",
    previousPath: "GSTReport",
    title: "GST Report",
    component: GSTReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/TransactionReport",
    previousPath: "Financial",
    title: "Transaction Report",
    component: TransactionReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/OrganisationRoleReport",
    previousPath: "Financial",
    title: "Organisation Role Report",
    component: OrganisationRoleReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/DeferredIncomeReport",
    previousPath: "Financial",
    title: "Deferred Income Report",
    component: DeferredIncomeReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "financial/MemberYearTwoReport",
    previousPath: "Financial",
    title: "Year 2 Member Report",
    component: MemberYearTwoReport,
    roles: [1, 2, 3, 4, 7, 9, 10, 11, 12, 13, 14],
    hasParams: true,
  },



  // Booking Start
  {
    path: "booking/ViewNewBookings",
    previousPath: "Booking",
    title: "View New Bookings",
    component: ViewNewBookings,
    roles: [1, 2, 10, 9, 12, 11, 13, 14],
    hasParams: false,
  },
  {
    path: "booking/ViewBookingCancellation",
    previousPath: "Booking",
    title: "View New Booking Cancellation",
    component: ViewBookingCancellation,
    roles: [1, 2, 10, 9, 12, 11, 13, 14],
    hasParams: false,
  },
  {
    path: "booking/NewBookingCancellationDetail/:cancellationId",
    previousPath: "Booking",
    title: "New Booking Cancellation Detail",
    component: NewBookingCancellationDetail,
    roles: [1, 2, 10, 9, 12, 11, 13, 14],
    hasParams: false,
  },

  // SLA Reports

  {
    path: "AllMemberReport",
    title: "All Member Report",
    previousPath: "SLA Reports",
    component: AllMemberReports,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "MembershipTrackingReport",
    title: "Membership Tracking Report",
    previousPath: "SLA Reports",
    component: MembershipTrackingReport,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "MemberMovementReport",
    title: "Member Movement Report",
    previousPath: "REDAS Reports",
    component: MemberMovementReport,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {
    path: "EventBookingReport",
    previousPath: "REDAS Reports",
    title: "Event Booking Report ",
    component: EventBookingReport,
    roles: [1, 3],
    hasParams: false,
  },
  // Un Authorized 
  {
    path: "authentication/UnAuthorized",
    previousPath: "UnAuthorized",
    title: "UnAuthorized",
    component: UnAuthorized,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "TestEditorPage",
    title: "Test Editor Page",
    component: TestEditorPage,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14],
  },
  {
    path: "financial/EventRegistrationApproval",
    previousPath: "Financial",
    title: "Event Registration Approval ",
    component: EventRegistrationApproval,
    roles: [1, 9, 10, 11, 13],
    hasParams: false,
  },
  {
    path: "financial/ExtractInvoices",
    previousPath: "Financial",
    title: "Extract Invoices",
    component: ExtractInvoices,
    roles: [1, 3],
    hasParams: false,
  },


  {
    path: "PublicationReport",
    previousPath: "",
    title: "Reports",
    component: PublicationReport,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },


  // Go Global Component Import
  {
    path: "goGlobal/GoGlobalContactRequest",
    previousPath: "GoGlobal",
    title: "Go Global Contact Request",
    component: GoGlobalContactRequest,
    roles: [1, 8, 11, 13],
    hasParams: false,
  },
  {
    path: "goGlobal/GoGlobalAccountApproval",
    previousPath: "GoGlobal",
    title: "Go Global Account Approval",
    component: GoGlobalAccountApproval,
    roles: [1, 8, 11, 13],
    hasParams: false,
  },
  {
    path: "goGlobal/ClickAnalytics",
    previousPath: "GoGlobal",
    title: "Click Analytics",
    component: ClickAnalytics,
    roles: [1, 8, 11, 13],
    hasParams: false,
  },
  {
    path: "goGlobal/ViewGoGlobalAccount",
    previousPath: "Go Global",
    title: "View Go Global Account",
    component: ViewGoGlobalAccount,
    roles: [1, 8, 11, 13],
    hasParams: false,
  },

  {
    path: "goGlobal/ViewGoGlobalAccount/:goGlobalMemberId",
    previousPath: "Go Global",
    title: "View Go Global Account",
    component: ViewGoGlobalAccount,
    roles: [1, 8, 11, 13],
    hasParams: true,
  },

  // DTSME
  {
    path: "DTSME",
    previousPath: " ",
    title: "DTSME",
    component: DTSME,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "dtsme/AddEditDTSMEMember",
    previousPath: "DTSME",
    title: "Add Edit DTSME Member",
    component: AddEditDTSMEMember,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },
  {
    path: "dtsme/DTSMEPurchaseReport",
    previousPath: "DTSME",
    title: "DT-SME Purchase Report",
    component: DTSMEPurchaseReport,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: false,
  },

  {
    path: "dtsme/AddEditDTSMEMember/:dtsmeMemberId",
    previousPath: "DTSME",
    title: "Add Edit DTSME Member",
    component: AddEditDTSMEMember,
    roles: [1, 9, 2, 10, 11, 12, 13, 14],
    hasParams: true,
  },
  {
    path: "ChangePassword",
    title: "Change Password",
    component: ChangePassword,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "Membership/MTOPricing",
    previousPath: "Membership",
    title: "MTO Pricing",
    component: MTOPricing,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "Membership/MTOTaskList",
    previousPath: "Membership",
    title: "MTO Task List",
    component: MTOTaskList,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "Membership/UpgradeChangeRequestTaskList",
    previousPath: "Membership",
    title: "Upgrade/Change Request TaskList",
    component: UpgradeChangeRequestTaskList,
    hasParams: false,
    roles: [1, 2, 12, 14],
  },
  {
    path: "MembershipReport",
    title: "Membership Reports",
    component: MembershipReport,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "AddEditSecretariatDetails",
    title: "AddEdit Secretariat Details",
    previousPath: "Website CMS",
    component: AddEditSecretariatDetails,
    hasParams: false,
    roles: [1, 7, 14]
  },
  {

    path: "AddEditSecretariatDetails/:SecretariatDetailsId",
    title: "Edit Secretariat Details",
    component: AddEditSecretariatDetails,
    hasParams: true,
    roles: [1, 7, 14]
  },
  {
    path: "ManageCommitteeMembers",
    title: "Committee Members",
    component: ManageCommitteeMembers,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {
    path: "AddEditCommitteemembers",
    title: "Add New Committee Member",
    previousPath: "Website CMS",
    component: AddEditCommitteeMembers,
    hasParams: false,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
  {

    path: "AddEditCommitteeMembers/:committeeDetailId",
    title: "Update Committee Member",
    component: AddEditCommitteeMembers,
    hasParams: true,
    roles: [1, 2, 3, 4, 7, 8, 9, 10, 11, 12, 13, 14, 6]
  },
];
export default ComponentNavigation;